import { render, staticRenderFns } from "./SupplierRiskTab.vue?vue&type=template&id=7821672e&"
import script from "./SupplierRiskTab.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports